// @flow
import React from 'react';
import { StyledLabel } from '@src/common-utils/styledComponents';

export const CommitGlobalDiscountNoteContainer = () => (
  <StyledLabel>Note: Global Discounts don&apos;t stack on any discounts added below</StyledLabel>
);
